export default "__VITE_ASSET__af660f8b__"